module.exports = __webpack_public_path__ + "static/media/MINDFULLY@2x.7613cdaa.png";